import styled from "styled-components";

export const ReadingPage = styled.div`
  min-height: calc(100vh - 160px);
  background: var(--page);
`;

export const ReadingFocus = styled.main`
  position: relative;
  padding: 64px 24px 88px;
  overflow: hidden;
  background: var(--paper-stage);
  box-shadow: inset 0px 0px 96px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 0px;
    overflow: visible;
    background: var(--page);
    box-shadow: none;
    cursor: default;
  }
`;

export const ReadingArticle = styled.article`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: 1120px;
  min-height: 68vh;
  margin: 0 auto;
  padding: 72px 88px 112px;
  border: 1px solid rgba(91, 78, 57, 0.18);
  border-radius: 2px;
  background-color: var(--paper);
  background-image:
    radial-gradient(circle at 12% 8%, rgba(178, 154, 104, 0.08), transparent 28%),
    radial-gradient(circle at 88% 64%, rgba(146, 125, 88, 0.055), transparent 24%),
    repeating-linear-gradient(
      0deg,
      rgba(88, 74, 48, 0.018) 0px,
      rgba(88, 74, 48, 0.018) 1px,
      transparent 1px,
      transparent 4px
    );
  box-shadow:
    0px 26px 70px rgba(0, 0, 0, 0.24),
    0px 2px 8px rgba(0, 0, 0, 0.12);
  font-family: "Literata", Georgia, serif;
  cursor: default;

  @media (max-width: 768px) {
    max-width: 320px;
    min-height: 58vh;
    padding: 56px 0px 88px;
    border: 0px;
    border-radius: 0px;
    background: var(--page);
    box-shadow: none;
  }
`;

export const ReadingContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 690px;
  margin: 0 auto;
`;

export const ReadingHeader = styled.header`
  position: relative;
  margin-bottom: 48px;
`;

export const ReadingBack = styled.a`
  display: inline-block;
  margin-bottom: 48px;
  color: var(--paper-muted);
  font-family: "Aktiv Grotesk Corp", "DM Sans", sans-serif;
  text-decoration: none;
  &:hover {
    color: var(--paper-text);
  }
`;

export const ReadingDate = styled.p`
  margin: 0px;
  color: var(--paper-muted);
  font-family: "Aktiv Grotesk Corp", "DM Sans", sans-serif;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const ReadingMetaRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 16px;
`;

export const ReadingShare = styled.button`
  margin: 0px;
  padding: 7px 10px;
  border: 1px solid rgba(91, 87, 78, 0.42);
  border-radius: 6px;
  color: var(--paper-muted);
  background: rgba(105, 101, 92, 0.055);
  font-family: "Aktiv Grotesk Corp", "DM Sans", sans-serif;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: var(--paper-text);
    border-color: var(--paper-text);
  }

`;

export const ReadingShareFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 54px;
  padding-top: 24px;
  border-top: 1px solid rgba(91, 78, 57, 0.16);

  @media (max-width: 768px) {
    margin-top: 44px;
  }
`;

export const ReadingTitle = styled.h1`
  margin: 0px 0px 18px;
  color: var(--paper-text);
  font-size: 44px;
  line-height: 54px;
  font-weight: 520;
  letter-spacing: -0.025em;
  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 41px;
  }
`;

export const ReadingDescription = styled.p`
  margin: 0px;
  color: var(--paper-muted);
  font-size: 18px;
  line-height: 30px;
  font-style: italic;
`;

export const ReadingImage = styled.img`
  position: relative;
  display: block;
  width: 100%;
  max-height: 560px;
  margin: 0px 0px 52px;
  object-fit: cover;
  border-radius: 4px;
  @media (max-width: 768px) {
    margin-bottom: 38px;
  }
`;

export const ReadingBody = styled.div`
  position: relative;
  color: var(--paper-text);
  font-size: 18px;
  line-height: 33px;
  font-weight: 400;
  p {
    margin: 0px 0px 28px;
  }
  @media (max-width: 768px) {
    font-size: 17px;
    line-height: 30px;
  }
`;

export const ReadingMessage = styled.p`
  position: relative;
  color: var(--paper-muted);
  font-family: "Aktiv Grotesk Corp", "DM Sans", sans-serif;
  font-size: 14px;
  line-height: 22px;
`;

export const ReadingRefresh = styled.button`
  margin: 0px;
  padding: 0px;
  border: 0px;
  color: inherit;
  background: transparent;
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
`;

export const ReadingFooter = styled.div`
  > div {
    margin-top: 0px;
  }
`;
